import { adminAPIInstance, axiosInstance } from "./axiosInstance";

export const getAllPublish = async (page, per_page = 50, search = "", publishable_type = "", publishable_status = "") => {
  try {
    const { data } = await axiosInstance.get("admin/publish", {
      params: {
        page: page,
        per_page: per_page,
        search: search,
        publishable_type: publishable_type,
        publishable_status: publishable_status
      },
    });

    return data;

  } catch (error) {
    console.log(error);
  }
};

export const updatePublishStatus = async (values) => {
  try {
    console.log(values);
    const { data } = await axiosInstance.post(`admin/publish/update/${values.publish_id}/${values.status}`, values);

    return data;

  } catch (error) {
    console.log(error);
  }
};
